// @owners { team: patients-team }
import { modal } from '~shared/actions';
import { getCurrentUser } from '~shared/features/users/selectors/getCurrentUser';
import { sendAnalyticsEvent } from '~shared/lib/analytics/src/actions';
import { connect } from '~shared/store';
import { type ReduxDispatchShared, type ReduxStateShared } from '~shared/types';
import ReferralModal from './ReferralModal';

const mapStateToProps = (state: ReduxStateShared) => {
  const user = getCurrentUser(state);
  return { ...state.modal, referralLink: user?.referral_link };
};

const mapDispatchToProps = (dispatch: ReduxDispatchShared) => {
  return {
    closeModal: () => {
      dispatch(modal.closeModal('REFERRAL_MODAL'));
    },
    // @ts-expect-error TS(7006): Parameter 'event' implicitly has an 'any' type.
    sendAnalyticsEvent: (event) => {
      dispatch(sendAnalyticsEvent(event));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReferralModal);
